import React from 'react'
import { ProgressBar } from 'react-bootstrap'
import { humanReadableByteCount } from './../../lib/helper'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

class FlywheelStats extends React.Component {
	render() {
		const { migrate, cancel, progress } = this.props
		return <div className="fw d-flex">
			<div className="container">
				<div className="jumbotron">
					<img className="bv-logo" src="/assets/blog-vault-logo@2x.png" alt=""/>
					<h1 className="fw-600">Your site is being migrated!</h1>
					<p>
						<a href={migrate.get('source_site')} target="_blank" className="font16">{ migrate.get('source_site') }</a>
						<img className="arrow-icon" src="/assets/arrow_right.svg" alt=""/>
						<a href={migrate.get('destination_site')} target="_blank" className="font16">{migrate.get('destination_site')}</a>
					</p>
				</div>
				<hr/>
				<div className="subsection">
					<h2 className="h3 text-center font13 fw-600">Sit back and relax while BlogVault robots move your site.</h2>
					<p className="text-center font13">You can monitor the progress, or close the window and wait for the completion email to arrive in your inbox.</p>
				</div>
				<div className="progress-group">
					<p className="progress-label font14">{ humanReadableByteCount(migrate.getIn(['status', 'files', 'size', 'synced'])) }/{ humanReadableByteCount(migrate.getIn(['status', 'files', 'size', 'total']) - migrate.getIn(['status', 'files', 'size', 'ignored'])) } - Files Synced</p>
					<ProgressBar now={ migrate.getIn(['status', 'files_progress']) }/>
					<div className="progress-percentage font16">
						{migrate.getIn(['status', 'files_progress'])}%
					</div>
				</div>
				<div className="progress-group">
					<p className="progress-label font14">{ migrate.getIn(['status', 'database', 'synced']) }/{ migrate.getIn(['status', 'database', 'total']) - migrate.getIn(['status', 'database', 'ignored']) } - Tables Synced</p>
					<ProgressBar bsStyle="success" now={ migrate.getIn(['status', 'tables_progress']) } />
					<div className="progress-percentage font16">
						{migrate.getIn(['status', 'tables_progress'])}%
					</div>
				</div>
				<div className="progress-group">
					<p className="progress-label font14">Overall Migration</p>
					<ProgressBar bsStyle="info" now={progress}/>
					<div className="progress-percentage font16">
						{progress}%
					</div>
				</div>
				<a className="text-link error font13" onClick={cancel}>Cancel Migration</a>
			</div>
		</div>
	}
}

FlywheelStats.propTypes = {
	migrate: ImmutablePropTypes.map,
	cancel: PropTypes.func,
	progress: PropTypes.number
}

export default FlywheelStats
